import actions from "./actions"

const initialState = {
    tariffsAll: [],
    tariffsLog: [],
    tariffLogDetail: {}
};

export default function tariffsReducers(state = initialState, action:{payload: any, type: any}):any{
    switch(action.type){
        case actions.SET_ALL_TARIFFS:
            return {...state, tariffsAll: action.payload};
        case actions.SET_TARIFFS_LOGS:
            return {...state, tariffsLog: action.payload};
        case actions.SET_TARIFFS_LOGS_BY_DATE_AND_WORKSPACE:
            return {...state, tariffsLog: action.payload};
        case actions.SET_TARIFF_LOG_DETAILS:
            return {...state, tariffLogDetail: action.payload};
        default:
            return state;
    }
}